import { AtomChannels, AtomTopics } from '@client/core/atoms/consts.js';
import { atom } from '@podium/store';
import type { MartailerPlacement } from '@schibsted-nmp/advertising-shared';

type MartailerAtom = {
  placements: Array<MartailerPlacement>;
  searchQuery?: string | undefined;
  categories?: string[] | undefined;
};

export const $martailerAtom = atom<$martailerAtom.Value>(
  AtomChannels.Podlet,
  AtomTopics.Martailer,
  {
    placements: [],
    searchQuery: undefined,
    categories: undefined
  }
);

export namespace $martailerAtom {
  export type Value = MartailerAtom;
}
